export const propFaqBooking = {
  faqEditor: {
    empty: "No questions yet. Add the first one so the agent knows how to answer it.",
    learnedTooltip: "Answer added through host self-learning",
    learnedBadge: "Learned",
    removeAttachment: "Remove attachment",
    uploading: "Uploading…",
    attach: "Attach",
    deleteTooltip: "Delete",
    addQuestion: "Add question",
    qPlaceholder: "Question · e.g. Is there parking?",
    aPlaceholder: "Answer · e.g. Yes, free right outside.",
    errors: {
      fillBeforeAttach: "Enter the question and answer before attaching files.",
      saveBeforeAttach: "Save first to attach files.",
      uploadFailed: "Could not upload the file.",
      deleteFailed: "Could not delete the file.",
    },
  },
  faqSuggestions: {
    title: "Suggestions to learn",
    intro: "The agent couldn't answer these questions and you replied to the guest. Review, edit if needed and save them so the agent can answer them on its own from now on.",
    askedLabel: "The guest asked",
    questionLabel: "Question",
    questionPlaceholder: "How would you phrase the question?",
    answerLabel: "Agent's answer",
    answerPlaceholder: "Answer the agent will give",
    applyToOthers: "Apply also to other units in the listing:",
    dismiss: "Dismiss",
    saveAsAnswer: "Save as answer",
    errors: {
      saveFailed: "Could not save.",
      dismissFailed: "Could not dismiss.",
    },
  },
  sourceNote: {
    title: "Agent answer priority order",
    infoAria: "View the agent's source priority order",
    lead: "When two sources say something different about the same detail, the agent follows this order:",
    faqPre: "FAQs ",
    faqStrong: "per individual unit",
    faqTag: "wins",
    configMain: "Accommodation settings",
    configMuted: "· hours, capacity, services",
    kb: "Knowledge base",
  },
  bookingLinks: {
    title: "How the guest books",
    subPre: "The agent sends your ",
    subStrong: "Direct Bookings",
    subPost: " link and the guest books on the web.",
    step1Pre: "If they name a ",
    step1Strong: "specific accommodation",
    step1Post: ", the agent sends its direct link.",
    step2Pre: "If there are ",
    step2Strong1: "several in that area",
    step2Mid: ", it ",
    step2Strong2: "lists each one with its link",
    step2Post: " plus the global one.",
    step3Pre: "If it doesn't know the area, it ",
    step3Strong: "suggests the available areas",
    step3Post: " and asks where they'd like to stay.",
    globalLinkLabel: "Global link (all locations)",
    copy: "Copy",
    copied: "Copied",
    noIdNote: "The booking link will be generated once your account has the identifier configured.",
    toastCopied: "Link copied",
    toastCopyFailed: "Couldn't copy",
  },
  bookingConfirm: {
    title: "Notify new booking",
    subPre: "When a booking is confirmed, we automatically notify the guest ",
    subStrong: "on WhatsApp",
    subPost: " with their stay details.",
    toggleLabel: "Send the confirmation on WhatsApp",
    toggleHint: "If you turn this off, this notification won't be sent to the guest. If the booking comes from an OTA, the OTA will notify them.",
    stateOn: "Yes, send it",
    stateOff: "Don't send",
    notEditablePre: "For now, the content of this message ",
    notEditableStrong: "can't be edited",
    notEditablePost: ". We're showing you a preview of what the guest receives.",
    previewTag: "Preview · what the guest sees",
    online: "online",
    today: "Today",
    previewHint: "Updates with your configuration",
    defaultListingName: "Accommodation",
    toastEnabled: "Booking notification enabled",
    toastDisabled: "Booking notification disabled",
    toastSaveFailed: "Couldn't save the change",
    previewGuest: "Laura García",
    previewBody: "Hi *{guest}* 👋\n\nYour booking at *{name}* is confirmed ✅\n\nBooking code: *6233Q1VC5*\nDates: *05/06/2026* – *07/06/2026* 📅\n\nThrough this WhatsApp you can request your online check-in link and also receive arrival instructions.\nIf you need help before or during your stay, message us here 💬",
    previewCta: "🇪🇸 To continue with check-in, tap the *Ok* button or type *Ok*.",
  },
};
